import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';
import {
  Grid,
  Input,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  Radio,
} from '@material-ui/core';
import { AssuranceIcon } from 'images';
import React from 'react';
import {
  getCategoryParamPAC,
  updatePACObject,
} from '../../../store/pac/actions';
import {
  ErrorTitle,
  PrimaryTitleCard,
  StyledListItemText,
  StyledSecondaryTitle,
  useStyles,
} from '../DeclareFolderProcess/styles';

interface ListItemsProps {
  titleCard: string;
  activeSearch?: boolean;
  listItems: {
    name: string;
    label: string;
    icon?: any;
    secondTitle?: string;
  }[];
  activeStep: number;
  radioButtonName: string;
}
const ListItems = ({
  listItems,
  titleCard,
  activeSearch,
  activeStep,
  radioButtonName,
}: ListItemsProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [items, setItems] = React.useState<ListItemsProps['listItems']>(
    listItems,
  );
  const { values } = useFormikContext<any>();

  /* istanbul ignore next */
  const handleOnClick = (value: any) => {
    switch (activeStep) {
      case 0:
        dispatch(
          updatePACObject({
            numPolice: value.numPolice,
            Identifiant: value.name,
          }),
        );
        dispatch(
          getCategoryParamPAC({
            numPolice: value.numPolice,
            Identifiant: value.name,
          }),
        );
        break;
      case 1:
        dispatch(
          updatePACObject({
            category: {
              id: value.name,
              label: value.label,
            },
          }),
        );
    }
  };

  /* istanbul ignore next */
  const searchItems = (searchValue: string) => {
    const filtredData = listItems.filter((item) => {
      return Object.values(item)
        .join('')
        .toLowerCase()
        .includes(searchValue.toLowerCase());
    });
    setItems(filtredData);
  };

  React.useEffect(() => {
    setItems(listItems);
  }, [listItems]);

  const { setFieldValue, errors, touched } = useFormikContext<any>();

  return (
    <>
      <Grid style={{ padding: 10 }}>
        <PrimaryTitleCard style={{ marginBottom: 10 }} fontSize="16px">
          {titleCard}
        </PrimaryTitleCard>
        <ErrorTitle>
          {touched[radioButtonName] &&
            errors[radioButtonName] &&
            errors[radioButtonName]}
        </ErrorTitle>
        {activeSearch && (
          <Input
            placeholder={intl.formatMessage({ id: 'map_filter.research' })}
            className={classes.inputTextStyle}
            disableUnderline={true}
            onChange={
              /* istanbul ignore next */ (e) => searchItems(e.target.value)
            }
            startAdornment={
              <InputAdornment position="start">
                <img
                  style={{ marginLeft: 8 }}
                  src={AssuranceIcon.searchIcon}
                  alt="search icon - saham assurance"
                />
              </InputAdornment>
            }
          />
        )}
      </Grid>

      <List
        className={classes.root}
        style={{ maxHeight: 500, overflow: 'auto' }}
        dir="ltr"
      >
        {items.map((value: any, key) => {
          return (
            <ListItem
              onClick={
                /* istanbul ignore next */
                () => {
                  handleOnClick(value);
                  setFieldValue(
                    radioButtonName as string,
                    radioButtonName === 'organisme'
                      ? value.numPolice
                      : value.name,
                  );
                }
              }
              key={key}
              dense
              style={{
                background: '#FFFFFF',
                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
                borderRadius: '6px',
                marginBottom: 10,
              }}
              dir="ltr"
            >
              <ListItemIcon style={{ minWidth: '30px' }}>
                <Radio
                  edge="start"
                  tabIndex={-1}
                  classes={{ root: classes.radio, checked: classes.checked }}
                  size="small"
                  checked={
                    radioButtonName === 'organisme'
                      ? value.numPolice === values.organisme
                      : value.name === values.category
                  }
                  value={
                    radioButtonName === 'organisme'
                      ? value.numPolice
                      : value.name
                  }
                  onChange={
                    /* istanbul ignore next */
                    (event) =>
                      setFieldValue(
                        radioButtonName as string,
                        event.currentTarget.value,
                      )
                  }
                />
              </ListItemIcon>
              <Grid
                style={{
                  marginLeft: 10,
                  alignItems: 'flex-start',
                }}
                container
                direction="column"
              >
                <StyledListItemText primary={value.label} />
                {value.secondTitle && (
                  <StyledSecondaryTitle variant="body2">
                    {value.secondTitle}
                  </StyledSecondaryTitle>
                )}
              </Grid>

              {value.icon && (
                <ListItemSecondaryAction>
                  <img src={AssuranceIcon[value.icon]} alt="" />
                </ListItemSecondaryAction>
              )}
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
export default ListItems;
